import React from 'react';
import InsightsComponent from '../../components/insights';

const InsightsContainer = () => {
    return <InsightsComponent />;
};

export default InsightsContainer;
